import { Controller } from '@hotwired/stimulus'

export default class ReportsFlashScrollController extends Controller {
  connect() {
    this.observer = new MutationObserver(() => {
      if (typeof this.element.scrollIntoView !== 'function') return

      if (this.element.textContent.trim() !== '') {
        this.element.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    })

    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer.disconnect()
  }
}
